export default import.meta.ROLLDOWN_FILE_URL_mQ1chtekZdgYYVLLU5nvgg